import { ArrowBigRight } from "lucide-react";
import { Alert, Card } from "react-bootstrap";

const SummaryCard = ({ summary }) => {
  return (
    <Card>
      <Card.Header className="border-bottom">
        <Card.Title className="d-flex justify-content-between m-0">
          Last Update
          <div className="d-inline-block text-muted">
            {summary?.lastUpdated}
          </div>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Card.Title>{summary?.rwwId}</Card.Title>
        <Card.Subtitle className="text-muted mb-3">
          <em>Rack Item ID: {summary?.rackItemId}</em>
        </Card.Subtitle>
        <div className="d-flex justify-content-between align-items-center">
          <Alert variant="info" className="flex-fill text-center mb-0">
            <div className="alert-message">
              <div className="text-muted">From</div>
              Rack ID: <strong>{summary?.prevRackId}</strong>
            </div>
          </Alert>
          <ArrowBigRight size={30} className="mx-5" />
          <Alert variant="info" className="flex-fill text-center mb-0">
            <div className="alert-message">
              <div className="text-muted">To</div>
              Rack ID: <strong>{summary?.newRackId}</strong>
            </div>
          </Alert>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SummaryCard;
